export default "__VITE_ASSET__b9ac7f68__"